var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2147227417(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#DEE8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2899_7915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4375 26.2334L31.0234 32.2961L30.4375 39.3951C29.7906 39.3951 29.2656 38.8709 29.2656 38.2232V27.4053C29.2656 26.7584 29.7906 26.2334 30.4375 26.2334Z",
    fill: "#A4B3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6094 27.4053V38.2232C31.6094 38.8709 31.0844 39.3951 30.4375 39.3951V26.2334C31.0844 26.2334 31.6094 26.7584 31.6094 27.4053Z",
    fill: "#A4B3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9531 39.0555C18.3059 39.0555 17.7812 38.5308 17.7812 37.8836V32.874C17.7812 32.2268 18.3059 31.7021 18.9531 31.7021C19.6003 31.7021 20.125 32.2268 20.125 32.874V37.8836C20.125 38.5308 19.6003 39.0555 18.9531 39.0555Z",
    fill: "#A4B3D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9663 20.5803L51.764 16.8725C52.032 16.5178 52.0757 16.042 51.878 15.6443C51.6796 15.2467 51.2734 14.9951 50.8288 14.9951H41.2812L40.1093 15.8092C40.0737 15.8092 40.0039 26.0289 40.0039 26.0289C40.0387 26.032 40.0737 26.0342 40.1093 26.0342H50.8288C51.2773 26.0342 51.6859 25.7787 51.882 25.3764C52.0788 24.9732 52.028 24.4936 51.7515 24.1404L48.9663 20.5803Z",
    fill: "#3FBF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2812 14.9951V38.2232C41.2812 38.8709 40.7563 39.3951 40.1094 39.3951C39.4617 39.3951 38.9375 38.8709 38.9375 38.2232V16.167C38.9375 15.5193 39.4617 14.9951 40.1094 14.9951H41.2812Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7025 42.3211L47.5666 37.6781C47.3447 37.4281 47.0259 37.2852 46.6916 37.2852H34.6127L31.3984 39.7253V46.4747L34.597 49.0039H46.6916C47.0298 49.0039 47.3509 48.8578 47.5736 48.6031L51.7095 43.8719C52.0986 43.4273 52.0955 42.7625 51.7025 42.3211Z",
    fill: "#234EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4371 37.2852L33.9527 43.4922L30.4371 49.0039H23.3105L20.0996 46.1398V39.5094L23.3168 37.2852H30.4371Z",
    fill: "#4E6FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7969 43.9689L23.3109 49.0049H13.1719C12.525 49.0049 12 48.4807 12 47.833V38.458C12 37.8111 12.525 37.2861 13.1719 37.2861H23.3172L27.8039 42.4182C28.193 42.8627 28.1898 43.5275 27.7969 43.9689Z",
    fill: "#94A6CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4375 21.5459L31.3991 24.2604L30.4375 28.5771C28.4992 28.5771 26.9219 27.0006 26.9219 25.0615C26.9219 23.1232 28.4992 21.5459 30.4375 21.5459Z",
    fill: "#3FBF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9531 34.0459C20.8948 34.0459 22.4688 32.4719 22.4688 30.5303C22.4688 28.5886 20.8948 27.0146 18.9531 27.0146C17.0115 27.0146 15.4375 28.5886 15.4375 30.5303C15.4375 32.4719 17.0115 34.0459 18.9531 34.0459Z",
    fill: "#3FBF8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5844 44.0127L34.5977 49.0049H30.4375V37.2861H34.6133L39.5922 42.3643C40.0422 42.8229 40.0391 43.5588 39.5844 44.0127Z",
    fill: "#4E6FB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9531 25.0615C33.9531 27.0006 32.3758 28.5771 30.4375 28.5771V21.5459C32.3758 21.5459 33.9531 23.1232 33.9531 25.0615Z",
    fill: "#3FBF8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2899_7915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147227417);
export default __webpack_public_path__ + "static/media/Frame 2147227417.ae3cc44d65c0f2aa82f17493ac47dbac.svg";
export { ForwardRef as ReactComponent };